<script context="module">
  import { get, writable } from "svelte/store";
  import {
    CachedRenderer,
    CanvasPoolManager,
  } from "../util/fast-canvas-pool.js";

  const canvasPoolCache = CachedRenderer({ size: 64 });
  const DIMENSIONS = 768;
  const ITEMS_PER_PAGE = 64;

  const memory = new Map();

  // function PageStore () {
  //   const mapStore = writable(new Map());
  //   return {
  //     set (pageIndex, data) {
  //       mapStore.update(map => {
  //         map.set()
  //         return map;
  //       });
  //     }
  //   }
  // }

  function getPageStore(addressKey) {
    addressKey = addressKey || "root";
    if (!memory.has(addressKey)) {
      memory.set(addressKey, []);
    }
    return memory.get(addressKey);
  }
</script>

<script>
  import { getContext, onDestroy, onMount } from "svelte";
  import Button from "./Button.svelte";
  import {
    hexToEncoding,
    encodingToHex,
    createEmptyEncoding,
    renderToCanvas,
  } from "bitframes";
  import {
    fetchOpenEditionTokenCount,
    fetchTokens,
  } from "../util/data-fetcher.js";
  import {
    colorSpace,
    CONTRACT_NETWORK,
    getBackground,
  } from "../util/constants";
  import { link } from "../util/anchor-link.js";
  import Footer from "./Footer.svelte";
  import UserLink from "./UserLink.svelte";

  export let address = "";
  export let system = 0x00;

  const EMPTY_ENCODING_HEX = encodingToHex(createEmptyEncoding());

  let curBackground;
  curBackground = getBackground({ system });
  $: curBackground = getBackground({ system });

  let loading = true;

  const gallery = getContext("gallery");
  const compact = gallery.compact;
  const order = gallery.order;

  const pool = CanvasPoolManager({
    hatch: true,
    hatchContours: true,
    maxPaintsPerFrame: 2,
    maxPerFrame: 64,
    cache: canvasPoolCache,
    colorSpace,
    width: DIMENSIONS,
    height: DIMENSIONS,
    ignoreIntersection(target) {
      if (target.dataset.placeholder === "true") {
        return true;
      }
    },
  });

  const poolAction = pool.action;

  const curDataList = [];

  let curTokenCount = null;
  let firstRun = true;
  onMount(() => {
    updateTokenCount();
    loadNext();
    return () => {
      pool.destroy();
    };
  });

  async function updateTokenCount() {
    curTokenCount = await fetchOpenEditionTokenCount();
  }

  async function loadPage(pageIndex, opts = {}) {
    const { address = null } = opts;

    // const roundDownTo64 = Math.floor(num / ITEMS_PER_PAGE) * ITEMS_PER_PAGE;

    const store = getPageStore(address);
    if (store[pageIndex] && store[pageIndex].length == ITEMS_PER_PAGE) {
    }

    const page = await fetchTokens({
      offset: pageIndex * ITEMS_PER_PAGE,
      publisher: address,
      length: ITEMS_PER_PAGE,
    });
  }

  async function loadNext() {
    loading = true;
    // await new Promise((r) => setTimeout(r, 50));
    // const mem = getStore(address);
    // const offset = mem.offset;
    // const page = [];
    // const offset = 0;
    // const page = await fetchTokens({
    //   offset,
    //   length: ITEMS_PER_PAGE,
    //   publisher: address,
    // });
    // mem.offset += page.length;
    // mem.store.update((data) => {
    //   const newData = data.slice();
    //   page.forEach((p) => newData.push(p));
    //   return newData;
    // });
    // if (page.length === 0) {
    //   isEmpty = true;
    // }
    // curMinResult = 0;
    firstRun = false;
    loading = false;
  }

  function padResults(res, address) {
    const minCount = address ? 0 : 16;
    if (res.length < minCount) {
      res = res.slice();
      for (let i = res.length; i < minCount; i++) {
        res.push({
          seed: EMPTY_ENCODING_HEX,
          placeholder: true,
          token_id: "placeholder-" + i,
        });
      }
    }

    return res;
  }
</script>

<div class="container" class:compact={$compact}>
  <div class="info noselect">
    <span>
      {#if address}
        TOKENS MINTED BY
        <UserLink {address} bold resolve link={false} addressAsPlaceholder short
        ></UserLink>
      {:else if curTokenCount == null}
        ALL MINTED TOKENS
      {:else}
        ALL {curTokenCount} MINTED TOKENS
      {/if}{#if CONTRACT_NETWORK === "sepolia"}
        (SEPOLIA TESTNET){/if}
    </span>
  </div>
  <!-- {#if curDataList && curDataList.length === 0 && curMinResult === 0}
    <div class="no-tokens">
      No tokens found — newly minted tokens may take a few minutes to appear in
      the public gallery.
    </div>
  {/if} -->
  <div class="grid noselect">
    {#each curDataList as item, i (item.token_id)}
      <a
        use:link
        href={item.placeholder ? "" : `/gallery/token/${item.token_id}`}
      >
        <div
          use:poolAction={{ index: i }}
          data-address={address}
          data-encoding={item.seed}
          data-index={item.token_id}
          data-placeholder={item.placeholder}
          role="none"
          class="cell"
          class:valid={!item.placeholder}
          style={`background-color: ${curBackground};`}
          on:click={(ev) => {}}
        ></div>
      </a>
    {/each}
  </div>
  <div class="button-bar">
    <!-- {#if !isEmpty && !firstRun}
    <Button
      text="Load More"
      enabled={!loading}
      on:click={loadNext}
    ></Button>
    {/if} -->
  </div>
</div>
<Footer></Footer>

<style>
  .container {
    width: 100%;
    max-width: var(--max-width);
    padding: 40px;
    box-sizing: border-box;
    padding-bottom: 0;
    --size: 32px;
    --gap: 40px;
    --columns: 3;
  }

  .grid {
    width: 100%;
    overflow-y: auto;
    flex-grow: 1;
    overflow-x: hidden;
    grid-template-columns: repeat(var(--columns), minmax(var(--size), 1fr));

    display: grid;
    /* grid-template-columns: repeat(auto-fit, minmax(64px, 1fr)); */
    /* height: 100%; */
    /* grid-template-columns: repeat(3, minmax(0, 1fr)); */

    /* grid-template: repeat(3, 30vw) / repeat(3, 30vw);
    grid-gap: 10px; */
    /* grid-template-columns: 1fr 1fr 1fr 1fr; */
    /* grid-template-columns: 1fr 1fr 1fr; */
    /* grid-template-rows: 1fr 1fr 1fr; */
    grid-gap: var(--gap);
    padding: 0px;
    box-sizing: border-box;
  }

  .container.compact {
    padding: 20px;
    padding-bottom: 0;
    --gap: 20px;
    --columns: 5;
  }

  .cell {
    aspect-ratio: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
    /* position: relative; */
  }

  .button-bar {
    width: 100%;
    margin-top: 40px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .info,
  .no-tokens {
    /* font-style: italic; */
    padding-bottom: 20px;
    font-size: 12px;
    /* text-transform: uppercase; */
    /* width: 100%; */
    justify-content: flex-start;
    display: flex;
    align-items: flex-start;
  }
  .no-tokens {
    /* color: tomato; */
    font-style: italic;
  }

  @media screen and (max-width: 720px) {
    .container,
    .container.compact {
      padding: 20px;
      padding-bottom: 0;
      --gap: 20px;
      --columns: 2;
    }
  }
  @media screen and (max-width: 720px) {
    .button-bar {
      /* margin-bottom: 40px; */
    }
  }
  @media screen and (max-width: 900px) {
    .container,
    .container.compact {
      padding: 20px;
      padding-bottom: 0;
      --gap: 20px;
      /* --columns: 2; */
    }
  }
</style>
